/**
 * 占位页面：显示对齐原型的菜单叶子 label + pageCode。
 *
 * MUST NOT 脱离原型 label 自行发挥业务文案；业务页面内容由后续 Change（2-x~6-x）填充。
 * 视觉：AntD Card 包裹 + Empty 空态，清晰传达「此处待填充」，但不渲染业务内容。
 * 卡片阴影对齐原型 token（偏移 + 柔焦，craft floor）。覆盖 admin-web-shell:SC-07。
 */
import { Card, Empty, Typography } from 'antd';
import type { MenuLeaf } from '../layout/menuConfig';
import { SHADOW_CARD } from '../theme';

const { Title, Paragraph, Text } = Typography;

export function PlaceholderPage({ leaf }: { leaf: MenuLeaf }) {
  return (
    <Card variant="borderless" style={{ boxShadow: SHADOW_CARD }}>
      <Title level={3} style={{ marginTop: 0 }}>
        {leaf.label}
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 24 }}>
        <Text code>{leaf.pageCode}</Text>
      </Paragraph>
      <Empty description="该页面待后续版本开发" />
    </Card>
  );
}
